import React, { useEffect, useState } from 'react';
import {
    displayPriceFormat,
    getMinimumPriceFreeProduct,
    isStringNotNull,
    roundNumber,
} from '../../../../../../../utils';
import { MarketingCampaignType, Offer, } from '../../../../../../../1_types/genericTypes';
import { useAppSelector } from '../../../../../../../redux/hook';
import { COLOR_GREY, DISHOP_GREEN, PRODUCT_STYLE_LIST, UNIT, } from '../../../../../../../constants';
import { getProductTempPrice } from '../../../../../../../utils/offer';

type ProductPriceProps = {
  product: any;
  productOffer?: Offer;
};

export default function ProductPrice({
  product,
  productOffer,
}: ProductPriceProps) {
  const { price, unit } = product;
  const minimumPrice = getMinimumPriceFreeProduct(product);
  const { thresholdOffer } = useAppSelector((state) => state.offerReducer);
  const { totalProductPriceWithPromo } = useAppSelector(
    (state) => state.pendingOrderReducer
  );
  const { productStyle } = useAppSelector(
    (state) => state.configurationReducer
  );
  const [displayPromoPrice, setDisplayPromoPrice] = useState(null);

  useEffect(() => {
    if (!productOffer) return;
    const tempPrice = getProductTempPrice({ ...product, price: price || minimumPrice }, productOffer);
    if (tempPrice !== Number(price) && (tempPrice !== Number(minimumPrice) || productOffer?.type === MarketingCampaignType.PRODUCT_DISCOUNT_AFTER_THRESHOLD)) {
        setDisplayPromoPrice(roundNumber(tempPrice));
    } else {
        setDisplayPromoPrice(null);
    }
  }, [price, totalProductPriceWithPromo, thresholdOffer, productOffer]);
  return minimumPrice > 0 || price > 0 ? (
    price > 0 ? (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          columnGap: UNIT / 2,
          flexDirection:
            productStyle === PRODUCT_STYLE_LIST ? 'row' : 'column-reverse',
        }}
      >
        {displayPromoPrice !== null && (
          <h6
            className={`text-product`}
            style={{ color: DISHOP_GREEN, fontWeight: 600 }}
          >
            {displayPriceFormat(displayPromoPrice)}
            {isStringNotNull(unit) ? `/${unit}` : ''}
          </h6>
        )}
        <h6
          className={
            displayPromoPrice !== null ? '' : `text-product text-muted`
          }
          style={
            displayPromoPrice !== null
              ? {
                textDecoration: 'line-through',
                color: COLOR_GREY,
                fontSize: 14,
              }
              : {}
          }
        >
          {displayPriceFormat(price)}
          {isStringNotNull(unit) ? `/${unit}` : ''}
        </h6>
      </div>
    ) : (
      <>
        <h6 className='text-product text-muted font-italic' style={
          displayPromoPrice !== null
            ? {
              textDecoration: 'line-through',
              color: COLOR_GREY,
              fontSize: 14,
            }
            : {}
        }>
          {displayPromoPrice !== null ? (
            displayPriceFormat(minimumPrice)
          ) : (
            <>
              À partir de {displayPriceFormat(minimumPrice)}
            </>
          )}
          {isStringNotNull(unit) ? `/ ${unit}` : ''}
        </h6>

        {displayPromoPrice !== null &&
          <h6
            className={`text-product`}
            style={{ color: DISHOP_GREEN, fontWeight: 600 }}
          >
            À partir de {displayPriceFormat(displayPromoPrice)}
            {isStringNotNull(unit) ? `/${unit}` : ''}
          </h6>
        }
      </>
    )
  ) : <></>
}
